import React, { useState } from 'react';
import Layout from '../components/Layout';
import '../styles/custom.css';
import { useNavigate } from 'react-router-dom';

const WelcomePage: React.FC = () => {
    const [showContactModal, setShowContactModal] = useState<boolean>(false);
    const navigate = useNavigate();

    const handleClose = (): void => {
        window.location.href = "https://www.enlyte.com/solutions/casualty/network-management#providertools";
    };

    const handleProviderSearch = (): void => {
        navigate('/provider-search');
    };

    return (
        <Layout
            isWelcomePage
            onContactUs={() => setShowContactModal(true)}
            onClose={handleClose}>
            <div className="welcome-main-content">
                <div className="welcome-content">
                    <h1 className="welcome-title">
                        Welcome to the Workers' Compensation Medical Provider Network (MPN) search site
                    </h1>
                    <p className="welcome-paragraph">
                        <strong>Providers:</strong> Use this site to confirm your participation in the MPNs listed for your location(s).
                        This site allows you to see important information about you and how it is presented to injured workers and employers looking for a referral to a healthcare professional.
                    </p>
                    <p className="welcome-paragraph no-margin-bottom">
                        The California Regulation (CCR 9767.5.1. Physician Acknowledgments) require active acknowledgement by
                        Providers of their participation in a MPNs. Click on 'Provider Search' to look up your practice by name, phone or TIN.
                    </p>
                </div>

                <button
                    className="provider-search-btn"
                    onClick={handleProviderSearch}>
                    <img src={`${process.env.PUBLIC_URL}/provider-search-icon.png`} alt="Provider Search" className="provider-search-img" />
                    Provider Search
                </button>
            </div>

            {/* Contact Modal */}
            {showContactModal && (
                <div className="contact-modal-overlay">
                    <div className="contact-modal contact-modal-purple-border">
                        <div className="contact-modal-title contact-modal-title-lg">
                            For CA MPN Provider Support
                        </div>
                        <div className="contact-modal-text contact-modal-text-lg">
                            Contact Coventry Provider Relations at 1-800-937-6824
                        </div>
                        <div className="contact-modal-text contact-modal-text-md">
                            (Mon-Fri 08:00 AM to 05:00 PM PST)
                        </div>
                        <div className="contact-modal-text contact-modal-text-md contact-modal-text-bottom">
                            Or Email <a href="mailto:DemoUpdates@cvty.us.com">DemoUpdates@cvty.us.com</a>
                        </div>
                        <button
                            onClick={() => setShowContactModal(false)}
                            className="contact-modal-ok-btn contact-modal-ok-btn-purple">
                            OK
                        </button>
                    </div>
                </div>
            )}
        </Layout>
    );
};

export default WelcomePage;